import * as React from "react";
import Box from "@mui/material/Box";

import ReviewsReports from "../../components/reviews/ReviewsReports";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import { useLocation, useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import ProductVersionDropdown from "../../components/common/ProductVersionDropdown";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { appLogger, Http } from "../../../src/utils";
import { useContext, useEffect, useState } from "react";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_SUPERADMIN,
} from "../../model";
import { getDateTimeRange } from "../../../src/utils/data";
import NoProductMessage from "../../utils/common/NoProductMessage";

const ViewReviews: any = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date();
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";
  // const currDateVal = currDate.setHours(23, 59, 59, 999);
  stDate.setDate(currDate.getDate() - 7);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [productResponse, setProductResponse] = React.useState([] as any);
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);

  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [isLoading, setIsloading] = React.useState(true);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState("" as any);
  const [LastEvaluatedKey, setLastEvaluatedKey] = React.useState("");
  const [isFetching, setIsFetching] = useState(false);

  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");

  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextCorrelationReportStartDate,
    ContextCorrelationReportStartDate,
    setContextCorrelationReportEndDate,
    ContextCorrelationReportEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  const [startDateValue, setStartDateValue] = React.useState(
    ContextCorrelationReportStartDate
  );
  const [endDateValue, setEndDateValue] = React.useState(
    ContextCorrelationReportEndDate
  );
  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };

  const changeEndDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });

    setEndDateValue(timestamp);
  };
  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      fetchReportTicketsData();
      setIsloading(true);
    }
  }, [product, version, selectedProVerDataType]);

  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        fetchReportTicketsData();
        setIsloading(true);
      }
    }
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    setStartDateValue(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
    }
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (Array.isArray(contextProVersion)) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  }, [userInfo]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching || LastEvaluatedKey == "") return;
    fetchMoreListItems();
  }, [isFetching]);

  useEffect(() => {
    if (LastEvaluatedKey == "") {
      setIsFetching(false);
    }
  }, [isFetching]);

  // function handleScroll() {
  //   if (
  //     window.innerHeight + document.documentElement.scrollTop !==
  //       document.documentElement.offsetHeight ||
  //     isFetching
  //   )
  //     return;
  //   setIsFetching(true);
  // }
  // function handleScroll() {
  //   const endOfPage =
  //     window.innerHeight + window.pageYOffset >= document.body.offsetHeight;

  //   if (endOfPage || isFetching) return;
  //   setIsFetching(true);
  // }
  function handleScroll() {
    if (
      window.innerHeight + Math.round(window.scrollY) >=
        document.body.offsetHeight ||
      isFetching
    ) {
      // you're at the bottom of the page
      setIsFetching(true);
    }
  }

  const fetchReportTicketsData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }`;
      // &endDate=${endDateValue ? endDateValue : ""}
      const correlatedValue = `&correlatedValue=${location.state.topic}`;
      Http.get({
        url: `/api/v2/correlation/playstore?${proVerUrl}${correlatedValue}&items=15`,
        state: userInfo,
      })
        .then((response: any) => {
          if (response && response.Items && response.Items.Items) {
            setReportsTicketsData(response.Items.Items);
          }
          if (response && response.Items && response.Items.LastEvaluatedKey) {
            setLastEvaluatedKey(response.Items.LastEvaluatedKey.id);
          } else {
            setLastEvaluatedKey("");
          }
          setIsFetching(false);

          appLogger.info({
            infoObj: {
              method: "fetchReportTicketsData",
              component: "cuvo-metrics-dashboard",
              fileName: "index.tsx",
              InsightsData: response.feedbackMetrics,
            },
          });
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
        });
    } else {
      setIsloading(false);
    }
  };

  const fetchMoreListItems = () => {
    // alert("fetchMoreListItems");

    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }`;
      // &endDate=${endDateValue ? endDateValue : ""}
      const correlatedValue = `&correlatedValue=${location.state.topic}`;
      const lastEvalKeyId = `&lastEvalKeyId=${LastEvaluatedKey}`;
      Http.get({
        url: `/api/v2/correlation/playstore?${proVerUrl}${correlatedValue}${lastEvalKeyId}&items=15`,
        state: userInfo,
      })
        .then((response: any) => {
          if (response && response.Items && response.Items.Items) {
            setReportsTicketsData([
              ...reportsTicketsData,
              ...response.Items.Items,
            ]);
          }
          if (response && response.Items && response.Items.LastEvaluatedKey) {
            setLastEvaluatedKey(response.Items.LastEvaluatedKey.id);
          } else {
            setLastEvaluatedKey("");
          }
          setIsFetching(false);

          appLogger.info({
            infoObj: {
              method: "fetchReportTicketsData",
              component: "cuvo-metrics-dashboard",
              fileName: "index.tsx",
              InsightsData: response.feedbackMetrics,
            },
          });
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
        });
    } else {
      setIsloading(false);
    }
  };
  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setStartDateValue(null);
    setEndDateValue(null);
    // getDateTimeRange(null);

    setFilterDate({
      startDate: "",
      endDate: "",
    });
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  const handleBackButton = () => {
    if (
      location &&
      location.state &&
      location.state.pageType == "mainReportPage"
    ) {
      const stateObj = {
        pageType: "mainReportPage",
      };
      navigate("/dashboard", { state: stateObj });
      // navigate("/dashboard");
    } else {
      navigate("/topics");
    }
  };

  return (
    <Grid
      sx={{ padding: "20px 45px" }}
      className={isLoading ? " chart-item loader" : "chart-item"}
    >
      <Box
        sx={{
          background: "#F6F6F6",
          padding: "10px",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <IconButton
          sx={{
            paddingTop: "8px",
          }}
          onClick={handleBackButton}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <g opacity="0.5" clip-path="url(#clip0_1205_1601)">
              <path
                d="M15.9782 7.30663C15.9086 7.29535 15.8383 7.29014 15.7678 7.29105H3.77466L4.03617 7.16942C4.29179 7.04843 4.52434 6.88377 4.7234 6.68288L8.08659 3.3197C8.52952 2.89687 8.60395 2.21667 8.26296 1.70805C7.86609 1.16605 7.105 1.04837 6.56297 1.44524C6.51918 1.47732 6.47756 1.51229 6.43844 1.54992L0.35674 7.63163C-0.118546 8.10638 -0.118964 8.87651 0.355789 9.3518C0.356093 9.3521 0.356436 9.35244 0.35674 9.35275L6.43844 15.4345C6.91411 15.9088 7.68424 15.9077 8.15862 15.4321C8.19594 15.3946 8.2308 15.3548 8.26296 15.3128C8.60395 14.8042 8.52952 14.124 8.08659 13.7012L4.72949 10.3319C4.55103 10.1533 4.34584 10.0035 4.12132 9.88794L3.75641 9.72373H15.7009C16.3222 9.74681 16.8674 9.31276 16.9841 8.70201C17.0917 8.03891 16.6413 7.41421 15.9782 7.30663Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_1205_1601">
                <rect width="17" height="17" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </IconButton>
        <span style={{ fontSize: "13px", color: "#3b3939" }}>
          Correlation / Review Categories /{" "}
        </span>
        <span>
          <span style={{ fontSize: "13px", fontWeight: "bold" }}>
            Topic:&nbsp;
          </span>
          <span style={{ fontSize: "13px", color: "#3b3939" }}>
            {location.state.topic}
          </span>
        </span>
        {/* <Typography
          onClick={handleBackButton}
          sx={{
            color: "#000000",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ChevronLeftIcon /> {location.state.topic}
        </Typography> */}
        {/* <Button
          variant="text"
          sx={{
            color: "#2858D3",
            fontWeight: 600,
          }}
          startIcon={<ChevronLeftIcon />}
          // onClick={handleBackButton}
        >
          BACK
        </Button> */}
      </Box>
      <br></br>
      {/* {renderNoProductMessage()} */}
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-view-tickets"
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3} lg={2.3} sx={{ ml: "auto" }}>
          <Box>
            <TextField
              disabled
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="datetime-local"
              value={startDateValue ? getDateTimeRange(startDateValue) : ""}
              onChange={(newValue: any) => {
                changeStartDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: maxDateTime.toISOString().slice(0, 16),
              }}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={6} sm={4} md={3} lg={2.3}>
          <Box>
            <TextField
              disabled
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              value={endDateValue ? getDateTimeRange(endDateValue) : ""}
              onChange={(newValue: any) => {
                changeEndDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateTimeRange(startDateValue),
                max: maxDateTime.toISOString().slice(0, 16),
              }}
              type="datetime-local"
            />
          </Box>
        </Grid> */}
        {/* {startDateValue || endDateValue ? (
            <Grid item className="clear-option" title="Clear">
              <CloseIcon onClick={clearDate} />
            </Grid>
          ) : (
            ""
          )} */}
      </Grid>
      {reportsTicketsData && (
        <ReviewsReports
          reportsTicketsData={reportsTicketsData}
          contextProVersion={contextProVersion}
          isFetching={isFetching}
          topic={location.state.topic}
        />
      )}
    </Grid>
  );
};

export default ViewReviews;
